export default __webpack_public_path__ + "static/media/np_cart.44b28ee1.svg";